/* sk-account.js — shared behaviour for the customer-account pages.
   1. Login: toggle the "forgot password" recover form.
   2. Addresses: open/close the add + edit <dialog> modals.
   Country/province selectors are wired in the addresses section itself
   (they need Shopify's global, loaded there). */
(function () {
  "use strict";

  /* ---- Forgot-password toggle (login page) ---- */
  document.addEventListener("click", function (e) {
    var rec = e.target.closest("[data-sk-acc-recover]");
    if (rec) {
      e.preventDefault();
      var login = document.querySelector("[data-sk-acc-login]");
      var recover = document.querySelector("[data-sk-acc-recover-form]");
      if (login) login.hidden = true;
      if (recover) { recover.hidden = false; var f = recover.querySelector("input"); if (f) f.focus(); }
      return;
    }
    var cancel = e.target.closest("[data-sk-acc-recover-cancel]");
    if (cancel) {
      e.preventDefault();
      var login2 = document.querySelector("[data-sk-acc-login]");
      var recover2 = document.querySelector("[data-sk-acc-recover-form]");
      if (recover2) recover2.hidden = true;
      if (login2) login2.hidden = false;
      return;
    }

    /* ---- Address dialogs ---- */
    var opener = e.target.closest("[data-sk-acc-open]");
    if (opener) {
      e.preventDefault();
      var dlg = document.getElementById(opener.getAttribute("data-sk-acc-open"));
      if (dlg && typeof dlg.showModal === "function") dlg.showModal();
      else if (dlg) dlg.setAttribute("open", "");
      return;
    }
    var closer = e.target.closest("[data-sk-acc-close]");
    if (closer) {
      e.preventDefault();
      var dlg2 = closer.closest("dialog");
      if (dlg2 && typeof dlg2.close === "function") dlg2.close();
      else if (dlg2) dlg2.removeAttribute("open");
      return;
    }
  });

  /* If the URL is #recover (Shopify links here after a reset email), open it. */
  if (window.location.hash === "#recover") {
    var l = document.querySelector("[data-sk-acc-login]");
    var r = document.querySelector("[data-sk-acc-recover-form]");
    if (l && r) { l.hidden = true; r.hidden = false; }
  }

  /* ---- Panel navigation (hub tabs — account dashboard only) ---- */
  var accHub = document.querySelector('.sk-acc__hub');
  if (accHub) {
    var skAccShow = function (id) {
      document.querySelectorAll('.sk-acc__nav-link').forEach(function (a) {
        var on = a.dataset.accPanel === id;
        a.classList.toggle('sk-acc__nav-link--on', on);
        a.ariaCurrent = on ? 'page' : null;
      });
      document.querySelectorAll('.sk-acc__panel').forEach(function (p) {
        p.hidden = p.id !== id;
      });
      history.replaceState(null, '', '#' + id);
    };
    window.skAccShow = skAccShow;
    (function () {
      var hash = window.location.hash.replace('#', '');
      /* Resolve by DOM existence, not a fixed list — a gated panel (e.g. #subscription
         for non-subscribers) is absent, so deep-links to it fall back to Orders. */
      var target = hash ? document.getElementById(hash) : null;
      skAccShow(target && target.classList.contains('sk-acc__panel') ? hash : 'orders');
    })();
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-acc-panel]');
      if (!link) return;
      e.preventDefault();
      skAccShow(link.dataset.accPanel);
    });
    /* Typing a #hash in the address bar changes the hash without a reload —
       mirror it to the panels. replaceState in skAccShow can't re-fire this. */
    window.addEventListener('hashchange', function () {
      var h = window.location.hash.replace('#', '');
      var t = h ? document.getElementById(h) : null;
      if (t && t.classList.contains('sk-acc__panel')) skAccShow(h);
    });
  }

  /* ---- Report a problem (account hub) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-acc-report-form]');
    if (!form) return;
    e.preventDefault();

    var orderEl   = form.querySelector('[name="order"]');
    var typeEl    = form.querySelector('[name="problem_type"]');
    var noteEl    = form.querySelector('[name="note"]');
    var submitBtn = form.querySelector('[data-acc-report-submit]');
    var statusEl  = form.querySelector('[data-acc-report-status]');

    var order        = orderEl ? orderEl.value.trim() : '';
    var problem_type = typeEl  ? typeEl.value.trim()  : '';
    var note         = noteEl  ? noteEl.value.trim()  : '';
    var hook         = form.dataset.accReportHook || '';
    var email        = form.dataset.reportEmail   || '';
    var name         = form.dataset.reportName    || '';

    if (!order)        { if (statusEl) statusEl.textContent = 'Please select which order.'; return; }
    if (!problem_type) { if (statusEl) statusEl.textContent = 'Please select a problem type.'; return; }
    if (!hook) {
      if (statusEl) statusEl.textContent = 'Report unavailable. Email info@theshreddedkitchen.nz.';
      return;
    }

    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }
    if (statusEl) statusEl.textContent = '';

    var payload = JSON.stringify({ order: order, problem_type: problem_type, note: note, email: email, name: name });

    var done = function () {
      if (statusEl) statusEl.textContent = 'Thanks, we\'ll be in touch within 24 hours.';
      form.reset();
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Send report'; }
    };
    var fail = function () {
      if (statusEl) statusEl.textContent = 'Something went wrong. Email info@theshreddedkitchen.nz.';
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Send report'; }
    };

    if (navigator.sendBeacon) {
      var sent = navigator.sendBeacon(hook, new Blob([payload], { type: 'text/plain' }));
      if (sent) { done(); } else { fail(); }
    } else {
      fetch(hook, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload, keepalive: true })
        .then(done)
        .catch(fail);
    }
  });

  /* ---- Preferences: save to /apps/sk-portal via App Proxy ---- */
  /* FRONT-END-ONLY BUILD (Plan 04 advance). The fetch below targets
     section.settings.prefs_endpoint (default /apps/sk-portal).
     The Save button is INERT until the Shopify App Proxy is registered (Plan 0b)
     and the n8n workflow is deployed (see n8n-sk-prefs-workflow.md).
     Attribute namespace: data-acc-* (not data-allergen/data-cart-attr/data-cart-note
     — those are reserved by sk-cart.js global delegation). */
  (function () {
    var prefsWrap = document.querySelector('[data-acc-prefs-endpoint]');
    if (!prefsWrap) return;
    var endpoint = prefsWrap.dataset.accPrefsEndpoint || '/apps/sk-portal';
    var saveBtn = prefsWrap.querySelector('[data-acc-prefs-save]');
    if (!saveBtn) return;

    saveBtn.addEventListener('click', function () {
      var allergies = [];
      prefsWrap.querySelectorAll('[data-acc-allergen]').forEach(function (chip) {
        if (chip.getAttribute('aria-pressed') === 'true') {
          allergies.push(chip.dataset.accAllergen);
        }
      });
      var avoidEl    = prefsWrap.querySelector('[data-acc-avoid]');
      var deliveryEl = prefsWrap.querySelector('[data-acc-delivery]');
      var avoid      = avoidEl    ? avoidEl.value.trim()    : '';
      var delivery   = deliveryEl ? deliveryEl.value.trim() : '';

      saveBtn.disabled    = true;
      saveBtn.textContent = 'Saving...';

      fetch(endpoint + '?action=save_prefs', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ allergies: allergies, avoid: avoid, delivery: delivery })
      })
        .then(function (res) {
          if (!res.ok) { throw new Error('HTTP ' + res.status); }
          return res.json();
        })
        .then(function () {
          var st = prefsWrap.querySelector('[data-acc-prefs-status]');
          if (st) { st.textContent = 'Saved!'; st.classList.add('is-shown'); st.classList.remove('is-error'); }
          saveBtn.disabled    = false;
          saveBtn.textContent = 'Save preferences';
        })
        .catch(function () {
          var st = prefsWrap.querySelector('[data-acc-prefs-status]');
          if (st) { st.textContent = 'Could not save - please try again.'; st.classList.add('is-shown'); st.classList.add('is-error'); }
          saveBtn.disabled    = false;
          saveBtn.textContent = 'Save preferences';
        });
    });

    /* Chip toggle — flip aria-pressed; CSS drives the orange selected state */
    prefsWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-acc-allergen]');
      if (!chip) return;
      var pressed = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    });
  })();
})();
